import { ImportSearchResults } from "./importSearchResults.model";

export class ImportSchedule {
    id: number;
    name: string;
    description: string;
    displayedOwner?: string;
    userGroupId: number;
    userName: string;
    isDisabled: boolean;
    isDisabledColor?: string;
    modifiedDate: Date;
    userFeatureAccess?: { [key: string] : boolean }
    importItems: ImportItem[];
    dataSource: string;
    frequency: ImportFrequency;
    freqValue: number;
}

export class ImportItem {
    id: number;
    thingName: string;
    details: ImportItemDetails;
    refId: string;
    dataTypesSelected: ImportItemDataType[];
    dataTypeOptions: ImportItemDataType[];
    importScheduleId: number;
    timeStampParm: ImportItemDataType;
    isLoadingDataTypes?: boolean;
    isLoadingItemData?: boolean;
    feed: ImportFeed;
    latitudeDaily: number;
    longitudeDaily: number;
    radiusDaily: number;
    key: string;

    compareSyncResults: CompareSyncResults;
    compareStats: CompareMcStats;
}

export class CompareMcStats {
    kigNew: number;
    kigNameUpdate: number;
    kigProdIdUpdate: number;
    kigGroupUpdate: number;
    particleNew: number;
    particleNameUpdate: number;
    particleProdIdUpdate: number;
    particleGroupUpdate: number;
    syncNeeded: boolean;
}

export class ImportItemDetails {
    nodeName: string;
    nodeType: string;
    port_number: number;
    product_name: string;
    manufacturer: string;
    lsid: number;
    crop: string;
    useLocalTime: string;
    city: string;
    region: string;
    country: string;
    gateway_Type: string;
    station_Id_Uuid: string;
    user_Email: string;
    subscription_Type: string;
}

export class ImportItemDataType {
    id: number;
    name: string;
}

export enum ImportFeed {
    SubDaily = 'SubDaily',
    DailySum = 'DailySum',
    DailyAvgLL = 'DailyAvgLL',
    DailyObsLL = 'DailyObsLL',
    //DailyAvgSta = 'DailyAvgSta',
    DailyObsSta = 'DailyObsSta',
    Current = 'Current',
    Historical = 'Historical'
}


export enum ImportFrequency {
    Daily = 'Daily',
    Hourly = 'Hourly',
    Every30Min = 'Every30Min',
    Once = 'Once',
    Every15Min = 'Every15Min'
}

export class ImportScheduleInfo {
    id: number;
    name: string;
    description: string;
    userGroupId: number;
    userName: string;
    isDisabled: boolean;
    modifiedDate: Date;
    importItems: ImportItemInfo[];
    dataSource: string;
    frequency: number;
    freqValue: number;
}

export class ImportItemInfo {
    id: number;
    thingName: string;
    details: string;
    refId: string;
    dataTypes: string;
    importScheduleId: number;
    timeStampParm: string;
    feed: number;
    latitudeDaily: number;
    longitudeDaily: number;
    radiusDaily: number;
    key: string;
}

export class ImportCSVFileContent {
    uuid: string;
    tag: string;
    createdDate: Date;
    readingTypes: ImportReadingTypeCheck[];
    gpsLong: number;
    gpsLat: number;
    gpsAlt: number;
    locationDescription: string;

    newUUID: boolean;
    recordExists: boolean;
    missingRequiredField: boolean;
    validGPSInfo: boolean;
    numNewReadingTypes: number;
}

export class ImportReadingTypeCheck {
    type: string;
    value: string;
    //isNewType: boolean;
    isNewReading: boolean;
}

export class CSVFileAnalysisResults {
    records: number;
    uniqueUUIDs: number;
    newUUIDs: number;
    recordsWithGPS: number;
    existingRecords: number;
    numNewReadingTypes: number;
    recordsImported: number;
}

export class ImportLogsSearchCriteria {
    importScheduleId: number;
    startDate: Date;
    endDate: Date;
}

export class ImportLogs {
    createdDate: Date;
    message: string;
}

//----------

export class CompareSyncResults {
    deviceGroup: string;
    sensors: SensorBasicsForCompareSync[];
}

export class SensorBasicsForCompareSync {
    uid: string;
    name: string;
    product_id: string;
    product_name: string;
    group_names: string[];

    kigNew: boolean;
    kigNameUpdate: boolean;
    kigProdIdUpdate: boolean;
    kigGroupUpdate: boolean;

    particleNew: boolean;
    particleNameUpdate: boolean;
    particleProdIdUpdate: boolean;
    particleGroupUpdate: boolean;

    mcInvalidProductId: boolean;
}

//-------------

